<template>
    <v-autocomplete
        dense
        :error="errorBorder"
        :clearable="clearable && !readonly"
        :error-messages="error"
        :items="options"
        :label="label"
        :loading="loading"
        :readonly="readonly"
        :disabled="disabled"
        :hide-details="hideDetails"
        item-text="label"
        item-value="value"
        outlined
        v-model="selectedValue"
    >
        <template #prepend-item>
            <slot name="firstItem"></slot>
        </template>

        <template #prepend>
            <slot name="prepend"></slot>
        </template>

        <template v-slot:item="{item}">
            <span>
                <v-icon v-if="item.icon" :color="item.iconColor || ''" style="margin-right: 10px">
                    {{ item.icon }}
                </v-icon>
                {{ item.label != null ? item.label : item }}
            </span>
        </template>

        <template v-slot:selection="{item}">
            <span>
                <v-icon v-if="item.icon" :color="item.iconColor || ''" style="margin-right: 10px">
                    {{ item.icon }}
                </v-icon>
                {{ item.label != null ? item.label : item }}
            </span>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: 'Dropdown',

    props: {
        readonly: Boolean,
        disabled: Boolean,
        value: [String, Number, Boolean, Object],
        ajax: Boolean,
        data: [Array, String],
        label: String,
        errorBorder: {type: Boolean, default: false},
        clearable: {type: Boolean, default: false},
        error: {type: String, default: ''},
    },

    data() {
        return {
            options: [],
            requestId: 0,
            loading: false,
            initialized: false,
        };
    },

    computed: {
        hideDetails() {
            return this.error === '';
        },

        selectedValue: {
            get() {
                return this.value;
            },
            set(val) {
                if (val === this.value) return;

                this.$emit('input', val);

                const selectedItem = this.options.find((item) => item.value === val);

                if (selectedItem) {
                    this.$emit('selected', {
                        id: val,
                        label: selectedItem.label,
                    });
                }

                this.$emit('changes');
            },
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (!this.initialized) {
                    this.initialized = true;
                    this.loadOptions(newVal);
                }

                this.ensureValueInOptions(newVal);
            },
        },
        data: {
            deep: true,
            handler(newVal) {
                if (!this.ajax) {
                    this.options = newVal || [];
                    this.ensureValueInOptions(this.value);
                } else {
                    // Endpoint prop se promijenio (npr. v-if/v-else reuse instance) -
                    // ponovno ucitaj opcije da lista ne ostane stale.
                    this.loadOptions(this.value);
                }
            },
        },
    },

    methods: {
        loadOptions(valueForProtection) {
            if (!this.ajax) {
                this.options = this.data || [];
                this.ensureValueInOptions(valueForProtection);
                return;
            }

            const currentRequest = ++this.requestId;
            this.loading = true;
            this.$APICall(
                'get',
                'select/' + this.data,
                {protected: valueForProtection},
                (data, success) => {
                    if (currentRequest !== this.requestId) return;

                    this.loading = false;
                    if (!success) return;

                    this.options = data || [];

                    this.ensureValueInOptions(this.value);
                },
                false,
            );
        },

        ensureValueInOptions(val) {
            if (val != null && !this.options.find((o) => o.value === val)) {
                // Zadrzi vrijednost validnom dok prava lista jos nije stigla, ali
                // nikad ne prikazuj raw id kao label (prazan label umjesto broja).
                this.options = [{value: val, label: ''}, ...this.options];
            }
        },
    },
};
</script>
